module.exports = __webpack_public_path__ + "img/8.f7b4aec9.jpg";